import { Molecule, wrap } from 'AppReact';
import styled, { css } from 'styled-components';
import { Text, Icon } from 'atoms';
import { Mr2 } from 'wrappers';

const template = styled.div`
  ${({ displayState, theme }) => css`
    display: flex;
    align-items: center;
    font-size: ${displayState.fontSize ? `${displayState.fontSize}px` : '16px'};
    font-weight: ${displayState.selected && displayState?.fontWeightOnSelection ? displayState?.fontWeightOnSelection : null};
    color: ${displayState.selected ? displayState?.primaryColor ? theme?.colour?.primary : theme?.colour?.secondary : `${theme?.colour?.secondary}4D`};
    cursor: pointer;
    margin-right: 23px;
    white-space: nowrap;

    &:hover {
      font-weight: 600;
      color: ${theme?.colour?.secondary};

      svg {
        fill: ${theme?.colour?.secondary};
      }
    }

    svg {
      fill: ${displayState.selected ? theme?.colour?.secondary : `${theme?.colour?.secondary}4D`};
      width: 17px;
      height: 17px;
      margin-right: 4px;
    }
  `}
`;

export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
      component: Icon,
      name: 'Icon',
      renderIf: ({ icon }) => !!icon,
      displayValue: ({ icon }) => icon
    },
    {
      component: wrap(Text, Mr2),
      name: 'Text',
      displayValue: ({ title }) => title,
    },
    {
      component: Text,
      renderIf: (state) => state.tabCount,
      name: 'Count',
      displayValue: ({ tabCount }) => String(tabCount),
    },
  ]
})